import { Box, Typography } from '@material-ui/core';
import AppDialog from 'components/basic/AppDialog';
import { TraitsCtx } from 'pages/TraitsPage';
import React, { useContext } from 'react';
import { useQueryClient, useMutation } from 'react-query';
import { SnpService } from 'services';
import { getTheme } from 'theme';
// import { useHistory, useLocation } from 'react-router';

function DeleteTraitDetailSnpsDialog() {
  const { delTraitDetailSnpsDialog, closedelTraitDetailSnpsDialog } = useContext(TraitsCtx);
  const queryClient = useQueryClient();
  // const history = useHistory();
  // const location = useLocation();
  const deleteMutation = useMutation((snp) => {
    return SnpService.delete(snp);
  }, {
    onSuccess: () => {
      return queryClient.invalidateQueries('snp')
        .then(() => {
          closedelTraitDetailSnpsDialog();
        });
    },
  });
  return (
    <AppDialog
      title='Delete Snp?'
      open={ delTraitDetailSnpsDialog.open }
      onClose={ () => { return closedelTraitDetailSnpsDialog(); } }
      onSubmit={ () => { return deleteMutation.mutate(delTraitDetailSnpsDialog.payload); } }
      loading={ deleteMutation.isLoading }
    >
      <Box style={ { padding: getTheme().spacing(2), maxWidth: 300 } }>
        <Typography>Are you sure you want to delete this Snp?</Typography>
      </Box>
    </AppDialog>
  );
}

export default DeleteTraitDetailSnpsDialog;
